<template lang="html">

  <div class="wrapper margin-menu">

    <section class="intro column-center -agua-para-todos">
      <h2>Agua para todos</h2>
      <h1>Proyectos en curso</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
        <router-link :to="$t('enlaces.proyectosencurso')">Proyectos en curso</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
        </h2>

        <p class="texto-intro">
          Actualmente estamos trabajando en los siguientes proyectos. Puedes consultar cada uno de ellos y ayudarnos a que se hagan realidad con tus aportaciones. 
        </p>

      </div>


      <section class="white-box objetivo-agua-para-todos">
        <div class="container row-start">
          <h2 class="big-title">Proyectos</h2>
        </div>
        <div class="title-container row-end">
          <h3 class="title-destacado -azul">Acceso a agua potable para más de 8.000 personas<br>en África, América y Asia.</h3>
        </div>

      </section>


      <section class="contenedor-proyectos-en-curso row-start container">

        <proyecto :key="key" :project="project" v-for="(project,key) in projectsNotfinish"></proyecto>


        <h2 class="title-destacado -aquamarine column-start"><span>Agua para</span><span>cambiar el mundo</span></h2>

      </section>


      <proyectos-finalizados></proyectos-finalizados>


    </main>

  </div>


</template>

<script lang="js">

import {mapActions, mapGetters} from 'vuex'

import proyecto from '@/components/parts/proyecto';
import proyectosfinalizados from '@/components/parts/projects-finalizados';

export default {
  name: 'proyectos-en-curso',
  mounted(){
    this.requestProyectos();
  },
  methods: {
    ...mapActions(['requestProyectos']),
  },
  computed : {
    ...mapGetters({
      projectsNotfinish : 'getProjectsNotfinish',
      projectsFinish : 'getProjectsNotfinish'
    })
  },
  components : {
    'proyecto' : proyecto,
    'proyectos-finalizados' : proyectosfinalizados,
  }
}
  
</script>


<style lang="scss">

</style>








// WEBPACK FOOTER //
// src/components/views/proyectos-en-curso.vue